import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';


export default types
    .model('Metadata', {
        completedPages: types.maybeNull(types.array(types.string)),
        lastVisitedPageId: types.maybeNull(types.string),
    })
    .actions(self => ({
        update(value) {
            applySnapshot(self, {
                ...getSnapshot(self),
                ...value,
            });
        },
    }));
